module.exports = __webpack_public_path__ + "static/media/img_give_back.f214f2fe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_give_back.webp
// module id = 813
// module chunks = 0